export default __webpack_public_path__ + "static/media/settings-new.ebd1badc.svg";